<template>
    <div data-app>
        <v-dialog v-model="advance_search_application.show" width="500">
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    Advance Search
                </v-card-title>
                <v-form v-model="valid" ref="form" class="filter-form">
                    <v-card-text class="scroll-area">
                        <v-autocomplete
                            v-model="advance_search_application.agents"
                            :items="getAgents"
                            cache-items
                            filled
                            dense
                            chips
                            small-chips
                            label="Agent"
                            multiple
                            item-value="id"
                            item-text="full_name"
                            :open-on-clear="true"
                            ref="agents"
                            @blur="blurDropdown('agents')"
                        >
                        </v-autocomplete>
                        <v-autocomplete
                            v-model="filter_values.brokers"
                            :items="getBrokers"
                            cache-items
                            filled
                            dense
                            chips
                            small-chips
                            label="Broker"
                            multiple
                            item-value="id"
                            item-text="name"
                            :open-on-clear="true"
                            ref="brokers"
                            @blur="blurDropdown('brokers')"
                        >
                        </v-autocomplete>
                        <v-autocomplete
                            v-model="advance_search_application.statuses"
                            :items="getAppStatusTypes"
                            dense
                            filled
                            chips
                            small-chips
                            label="Stage/Status"
                            multiple
                            item-value="id"
                            :item-text="getStageStatus"
                            :open-on-clear="true"
                            ref="statuses"
                            @blur="blurDropdown('statuses')"
                        >
                        </v-autocomplete>
                        <v-autocomplete
                            v-model="filter_values.introducers"
                            :items="getIntroducers"
                            dense
                            chips
                            filled
                            small-chips
                            label="Referrer"
                            multiple
                            item-value="id"
                            item-text="name"
                            :open-on-clear="true"
                            ref="introducers"
                            @blur="blurDropdown('introducers')"
                        >
                        </v-autocomplete>
                        <v-autocomplete
                            v-model="filter_values.lenders"
                            :items="getLenders"
                            dense
                            filled
                            chips
                            small-chips
                            label="Lenders"
                            multiple
                            item-value="id"
                            item-text="name"
                            :open-on-clear="true"
                            ref="lenders"
                            @blur="blurDropdown('lenders')"
                        >
                        </v-autocomplete>
                        <v-autocomplete
                            v-model="advance_search_application.loan_asset_types"
                            :items="getAssetTypes"
                            dense
                            chips
                            filled
                            small-chips
                            label="Asset type"
                            multiple
                            item-value="id"
                            item-text="name"
                            :open-on-clear="true"
                            ref="asset_types"
                            @blur="blurDropdown('asset_types')"
                        >
                        </v-autocomplete>
                        <v-autocomplete
                            v-model="advance_search_application.pods"
                            :items="getPods"
                            dense
                            chips
                            filled
                            small-chips
                            label="POD"
                            multiple
                            item-value="id"
                            item-text="description"
                            :open-on-clear="true"
                            ref="pods"
                            @blur="blurDropdown('pods')"
                            @change="handlePodSelectionChange"
                        >
                        </v-autocomplete>
                        <v-menu
                            ref="menu1"
                            v-model="menu1"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="advance_search_application.start_date"
                                    label="Start Date"
                                    persistent-hint
                                    prepend-icon="mdi-calendar"
                                    v-bind="attrs"
                                    v-on="on"
                                    filled
                                    :rules="startDateRule"
                                    required
                                    class="form-input"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="advance_search_application.start_date"
                                no-title
                                @input="menu1 = false"
                            ></v-date-picker>
                        </v-menu>


                        <v-menu
                            ref="menu2"
                            v-model="menu2"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="advance_search_application.end_date"
                                    label="End Date"
                                    persistent-hint
                                    prepend-icon="mdi-calendar"
                                    v-bind="attrs"
                                    v-on="on"
                                    filled
                                    :rules="endDateRule"
                                    required
                                    class="form-input"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="advance_search_application.end_date"
                                no-title
                                :min="advance_search_application.start_date"
                                @input="menu2 = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <md-button class="md-primary md-simple" @click="resetDialog"
                        >Clear</md-button
                        >
                        <v-spacer></v-spacer>
                        <md-button class="md-primary md-simple" @click="closeDialog"
                            >Cancel</md-button
                        >
                        <loading-icon-text-button
                            @click="applyFilter"
                            icon="search"
                            :loading="saving"
                            :disabled="!valid"
                        >
                            Apply
                        </loading-icon-text-button>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import WaitingDialog from "@/components/Dialogs/WaitingDialog";
import moment from "moment";

export default {
    components: {
        LoadingIconTextButton,
    },
    data() {
        return {
            temporaryPodSelection: [],
            temporaryChildPodSelection: [],
            saving: false,
            menu1: false,
            menu2: false,
            search: null,
            select: null,
            filterApplicationValues: {
                brokers:[]
            },
            filter_values: {
                brokers: [],
                introducers: [],
                lenders: [],
            },
            empty_broker: {
                email: "",
                id: 0,
                name: "Applications without Broker",
                name_detail: {
                    first_name: "",
                    last_name: "",
                },
                role: "broker",
            },
            empty_introducer: {
                email: "",
                id: 0,
                name: "Applications without Referrer",
                name_detail: {
                    first_name: "",
                    last_name: "",
                },
                role: "referrer",
            },
            empty_lender: {
                id: 0,
                name: "Applications without Lender",
            },
            valid: true,
            startDateRule: [
                v => !!v || 'Start date is required'
            ],
            endDateRule: [
                v => !!v || 'End date is required'
            ],
        };
    },
    watch: {
        "filter_values.brokers"() {
            this.setAdvancedSearchApplication("brokers");
        },
        "filter_values.introducers"() {
            this.setAdvancedSearchApplication("introducers");
        },
        "filter_values.lenders"() {
            this.setAdvancedSearchApplication("lenders");
        },
    },
    computed: {
        ...mapGetters([
            "user",
            "userHasPermission",
            "advance_search_application",
        ]),
        permissions() {
            return this.application_update_status_dialog &&
                this.application_update_status_dialog.application
                ? this.application_update_status_dialog.application.permissions
                : null;
        },
        getBrokers() {
            if (this.$store.state.administration_brokers) {
                return [this.empty_broker, ...this.$store.state.administration_brokers];
            }
            return [this.empty_broker];
        },
        getIntroducers() {
            if (this.$store.state.administration_introducers) {
                return [this.empty_introducer, ...this.$store.state.administration_introducers];
            }
            return [this.empty_introducer];
        },
        getAssetTypes() {
            return this.$store.state.administration_loan_asset_types ?? [];
        },
        getAppStatusTypes() {
            return this.$store.state.administration_app_status_types ?? [];
        },
        getPods() {
            return this.$store.state.administration_pods ?? this.$store.state.user.user_pods ?? [];
        },
        getLenders() {
            if (this.$store.state.administration_lenders) {
                return [this.empty_lender, ...this.$store.state.administration_lenders];
            }
            return [this.empty_lender];
        },
        getAgents() {
            return this.$store.state.administration_agents ?? [];
        },
    },
    methods: {
        getStageStatus(item) {
            return item.stage + '/' + item.status
        },
        blurDropdown(event) {
            this.$refs[event].isMenuActive = false;
        },
        handlePodSelectionChange(values) {
            this.$nextTick(() => {
                this.searchPods = this.getPods;
                this.advance_search_application.pods = [];
                this.advance_search_application.child_pods = [];
                for (let i in values) {
                    for (let x in this.searchPods) {
                        if (this.searchPods[x].parent_id == values[i] && !this.advance_search_application.child_pods.includes(values[i])) {
                            this.advance_search_application.child_pods.push(values[i]);
                            if (!this.advance_search_application.pods.includes(values[i])) {
                                this.advance_search_application.pods.push(values[i])
                            }
                        } else if (this.searchPods[x].id == values[i] && !this.advance_search_application.pods.includes(values[i])) {
                            this.advance_search_application.pods.push(values[i])
                        }
                    }
                }
                this.temporaryPodSelection = this.advance_search_application.pods;
                this.temporaryChildPodSelection = this.advance_search_application.child_pods;
            });
        },
        closeDialog(event) {
            this.advance_search_application.show = false;
            this.advance_search_application.active = true;
            this.$store.commit(
                "set_advance_search_application",
                this.advance_search_application
            );
        },
        resetDialog(event) {
            let advance_search_application = {
                show: true,
                active: false,
                brokers:[],
                stage: [],
                statuses:[],
                lenders:[],
                introducers: [],
                loan_asset_types:[],
                pod : [],
                start_date: null,
                end_date :  null,
                pods: [],
            };
            this.$store.commit(
                "set_advance_search_application",
                advance_search_application
            );
        },
        applyFilter() {
            this.closeDialog();
            this.$emit("searchapply", this.advance_search_application);
        },
        setAdvancedSearchApplication(type="") {
            if (!!type) {
                // copy filter_values to advance_search_application
                this.advance_search_application[type] = [...this.filter_values[type]];
                // 0 is id of Applications without Broker/Introducer/Lender
                let index = this.advance_search_application[type].indexOf(0);
                if (index > -1) {
                    // remove 0 from advance_search_application
                    this.advance_search_application[type].splice(index, 1);
                }
                // set flag
                this.setEmptySearch(type, (index > -1));
            }
        },
        setEmptySearch(type="", value=false) {
            if (!!type) {
                switch(type) {
                    case "brokers":
                        this.advance_search_application['get_empty_broker'] = value;
                        break;
                    case "introducers":
                        this.advance_search_application['get_empty_introducer'] = value;
                        break;
                    case "lenders":
                        this.advance_search_application['get_empty_lender'] = value;
                }
            }
        },
        setExistedFilterValues() {
            if (this.advance_search_application) {
                if (this.advance_search_application.brokers) {
                    this.filter_values.brokers = [...this.advance_search_application.brokers];
                }
                if (this.advance_search_application.introducers) {
                    this.filter_values.introducers = [...this.advance_search_application.introducers];
                }
                if (this.advance_search_application.lenders) {
                    this.filter_values.lenders = [...this.advance_search_application.lenders];
                }
                if (this.advance_search_application.get_empty_broker) {
                    this.filter_values.brokers.unshift(0);
                }
                if (this.advance_search_application.get_empty_introducer) {
                    this.filter_values.introducers.unshift(0);
                }
                if (this.advance_search_application.get_empty_lender) {
                    this.filter_values.lenders.unshift(0);
                }
            }
        },
    },
    created() {
        this.$modal.show(WaitingDialog, {
            title: "Fetching Data",
            message: "Please wait while we are fetching data",
        });

        Promise.all([
            this.$store.dispatch('fetch_administration_user_pods', false),
            this.$store.dispatch('fetch_administration_app_status_types', false),
            this.$store.dispatch('fetch_administration_loan_asset_types', false),
            this.$store.dispatch('get_broker_query',false),
            this.$store.dispatch('get_referrer_query', false),
            this.$store.dispatch('get_lender_query', false),
            this.$store.dispatch('fetch_administration_agents', false),
        ]).finally(() => {
            if (this.$modal.submit) {
                this.$modal.submit();
            }
        })
    },
    mounted() {
        this.setExistedFilterValues();
    },
};
</script>

<style scoped>
::v-deep .v-date-picker-table .v-btn.v-btn--active {
    color: #fff;
    background: #0014ff;
}

.scroll-area {
    max-height: 400px;
    overflow: auto;
}

form.v-form.filter-form .v-card__text.scroll-area {
    padding: 17px !important;
}

.form-input >>> .error--text {
  color: #ff5252 !important;
}

</style>
